export default __webpack_public_path__ + "static/events-light-09c6fad77bace81ba7aa3e9464272852.png";